import { AxiosInstance } from 'axios';

import { CreateFileSignedUploadIntent, VerifyFilesSignedUpload } from './inputs';
import { UploadIntentResource, VerifiedFileResource } from './resources';

export default class File {
    private basePath = '/api/file';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    createUploadIntent = async (input: CreateFileSignedUploadIntent): Promise<UploadIntentResource[]> => {
        const { data } = await this.http.post(`${this.basePath}/upload/signed/intent`, input);
        return data;
    };

    verifySignedUpload = async (input: VerifyFilesSignedUpload): Promise<VerifiedFileResource[]> => {
        const { data } = await this.http.post(`${this.basePath}/upload/signed/verify`, input);

        return data;
    };

    getDownloadableLink = (id: ID) => {
        const base = (this.http.defaults.baseURL ?? '').replace(/\/+$/, '');
        return `${base}${this.basePath}/${id}/download/signed`;
    };
}
